import { connect } from "react-redux";
import Branch from "../Components/branch/branch";
import { Settablehistory } from "../Service/Actions/action";
import { Setcurrentinfo } from "../Service/Actions/action";

const dispatchpart = (dispatch) => ({
  Settable_history: (data) => dispatch(Settablehistory(data)),
  Setinfo_ofuser: (data) => dispatch(Setcurrentinfo(data)),
});

const getpart = (state) => ({
  state,
});

export default connect(getpart, dispatchpart)(Branch);
